// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.JPG = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.JPG = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var JPG = _exports.JPG = function JPG(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.6655 12.0497V14.5639C6.66372 14.8782 6.52523 15.0433 6.2731 15.0433C6.03162 15.0433 5.88425 14.8888 5.87537 14.6065H5.00002C4.99647 15.3896 5.54334 15.7358 6.22338 15.7358C6.99398 15.7358 7.5302 15.2724 7.53198 14.5639V12.0497H6.6655Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.08374 15.6861H8.96264V14.5568H9.55923C10.392 14.5568 10.9122 14.0632 10.9122 13.3086C10.9122 12.5611 10.4026 12.0497 9.58587 12.0497H8.08374V15.6861ZM8.96264 13.8643V12.7582H9.39588C9.79006 12.7582 10.0013 12.9712 10.0013 13.3086C10.0013 13.6442 9.79006 13.8643 9.39588 13.8643H8.96264Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.7318 13.2376H14.6214C14.5326 12.5131 13.8863 12 13.0447 12C12.0734 12 11.3064 12.6836 11.3064 13.8732C11.3064 15.0238 12.0131 15.7358 13.0553 15.7358C13.9911 15.7358 14.6604 15.1552 14.6604 14.1786V13.6974H13.0926V14.3384H13.8135C13.8046 14.7219 13.5383 14.9652 13.0624 14.9652C12.5173 14.9652 12.2031 14.5621 12.2031 13.8626C12.2031 13.1683 12.5351 12.7706 13.0624 12.7706C13.414 12.7706 13.6537 12.9428 13.7318 13.2376Z",
      fill: "currentColor"
    }));
  };
});
